<template>
    <div class="columns is-centered">
        <div class="column is-one-third">
            <div class="bbbox">
                <p class="caption">Log in</p>
                <b-field label="Email/Username">
                    <b-input v-model="creds.username" type="email"></b-input>
                </b-field>
                <b-field label="Password">
                    <b-input v-model="creds.password" type="password" password-reveal></b-input>
                </b-field>
                <b-button @click="login" :disabled="isLoading">
                    <span v-if="isLoading">Please wait...</span>
                    <span v-else>Login</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                creds: {
                    username: null,
                    password: null
                },
                isLoading: false
            }
        },
        methods: {
            login() {
                const vm = this;
                vm.isLoading = true;
                vm.axios.post(`${vm.$host}/companyAdmins/login`, vm.creds)
                    .then(function (res) {
                        vm.isLoading = false;
                        localStorage.setItem('token', res.data.id);
                        localStorage.setItem('user', res.data.userId);
                        localStorage.setItem('companyId', res.data.companyId)
                        vm.$router.push({name: 'Home'})
                    })
                    .catch(function (err) {
                        vm.isLoading = false;
                        if (err.response.status === 401) {
                            alert("Incorrect username or password. Please try again.")
                        } else {
                            alert(err)
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>